<template>
  <v-select
    color="primary"
    variant="plain"
    return-object
    item-title="stage_configuration.name"
    hide-details
    v-model="selectedItem"
    :items="stabSchematisationStageItems"
  >
    <template v-slot:selection="{ item, props }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <div class="mr-3">
            <SchematisationStageDoneButton :item="item.raw" />
          </div>
        </template>
        <span>
          {{ item.raw.stage_configuration.name }}
        </span>
      </v-list-item>
    </template>
    <template v-slot:item="{ item, props }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <SchematisationStageDoneButton :item="item.raw" />
        </template>
        <template v-slot:title>
          <span class="ml-3">
            {{ item.raw.stage_configuration.name }}
          </span>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import SchematisationStageDoneButton from '@/components/schematisationDetail/SchematisationStageDoneButton.vue'

export default {
  name: 'SchematisationStageSelect',
  components: { SchematisationStageDoneButton },
  props: {
    index: {},
    item: {}
  },
  computed: {
    ...mapState('stabSchematisation', {
      loading: (state) => state.loading
    }),
    selectedItem: {
      get() {
        return this.currentStabSchematisationStage
      },
      async set(item) {
        if (this.currentStabSchematisationStage?.id !== item?.id) {
          await this.resetChildrenState()
        }
        await this.$router.push({
          name: 'schematisation-stage',
          params: { schematisationStageId: item.id }
        })
        return this.setCurrentStabSchematisationStage(item)
      }
    },
    ...mapState('stabSchematisationStage', {
      currentStabSchematisationStage: (state) => state.currentItem,
      stabSchematisationStageItems: (state) => state.items
    }),

    isCurrent() {
      return this.item.id === this.currentStabSchematisationStage.id
    }
  },
  methods: {
    ...mapActions('stabSchematisationStage', {
      setCurrentStabSchematisationStage: 'setCurrentItem'
    }),
    ...mapActions('stabSchematisation', {
      resetChildrenState: 'resetChildrenState'
    })
  }
}
</script>
<style scoped>
:deep(.v-field__input) {
  padding: 0 !important;
  padding-top: 12px !important;
}
</style>
